import React from "react"
import { useNavigate } from "react-router-dom"
import { BreadCrumb } from "primereact/breadcrumb"

export default function Breadcrumb({ items = [] }) {
  const navigate = useNavigate()

  const home = {
    icon: "pi pi-home",
    command: () => navigate("/"),
  }

  const breadcrumbItems = items.map((item) => ({
    label: item.label,
    command: item.path ? () => navigate(item.path) : undefined,
  }))

  return (
    <BreadCrumb
      model={breadcrumbItems}
      home={home}
      style={{
        marginBottom: 16,
        border: "none",
        padding: "12px 16px",
        fontSize: "1.1rem",
      }}
    />
  )
}
